import Component from '../abstracts/Component';
import OnDemandLiveRegion from "../utils/OnDemandLiveRegion";


export default class NotifyMeComponent extends Component {

  get COMPONENTNAME() {
    return 'NotifyMeComponent';
  }

  get SELECTORS() {
    return {
      notifyForm: '.c-pdp__notifyme__form',
      notifyMeBtn : '[data-notifyme=buttons]',
      addToCartBtn: '[data-addtocart=buttons]',
      formBtn: '.js-notify-me-btn',
      form: '#notificationForm',
      productCode: '#productCode',
      sizeHiddenInput: '#jsSizeSelectedInput',
      mailErrorBox: '.js-email-error',
      mailInput: '#email',
      sizeError: '.js-addtocart-notification',
      wishlistProduct: '.wishlist-card__selector',
      pdpProduct: '.c-pdp__service-column',
    };
  }

  get CLASSES() {
    return {
      formVisible: 'show',
      btnHidden: 'hidden',
      enableNotify: 'product-sizes-notify',
    }
  }

  constructor(compEl) {
    super(compEl);
    this.parent = this.$component.closest(this.SELECTORS.wishlistProduct) ||
      this.$component.closest(this.SELECTORS.pdpProduct);
    // component elements
    this.notifyForm = this.parent.querySelector(this.SELECTORS.notifyForm);
    this.form = this.parent.querySelector(this.SELECTORS.form);
    this.formBtn = this.parent.querySelector(this.SELECTORS.formBtn);
    this.productCode = this.parent.querySelector(this.SELECTORS.productCode);
    this.sizeHiddenInput = this.parent.querySelector(this.SELECTORS.sizeHiddenInput);
    this.mailInput = this.parent.querySelector(this.SELECTORS.mailInput);
    this.notifyMeBtn = this.parent.querySelector(this.SELECTORS.notifyMeBtn);
    this.addToCartBtn = this.parent.querySelector(this.SELECTORS.addToCartBtn);
    this.mailErrorBox = this.parent.querySelector(this.SELECTORS.mailErrorBox);
    this.sizeError = this.parent.querySelector(this.SELECTORS.sizeError);
    this.liveRegion = new OnDemandLiveRegion({
      level: "assertive",
      delay: 1000,
    });
  }

  // FORM FUNCTIONS
  toggleUnavailableForm(payload, show = true) {
    // get product element
    let parentEl = payload.closest(this.SELECTORS.wishlistProduct) ||
      payload.closest(this.SELECTORS.pdpProduct);;
    if ( show ) {
      // show form
      parentEl.querySelector(this.SELECTORS.notifyForm).classList.add(this.CLASSES.formVisible);
      // show notify btn
      parentEl.querySelector(this.SELECTORS.notifyMeBtn).classList.remove(this.CLASSES.btnHidden);
      // hide atc
      parentEl.querySelector(this.SELECTORS.addToCartBtn).classList.add(this.CLASSES.btnHidden);
    } else {
      // hide form
      parentEl.querySelector(this.SELECTORS.notifyForm).classList.remove(this.CLASSES.formVisible);
      // show atc
      parentEl.querySelector(this.SELECTORS.addToCartBtn).classList.remove(this.CLASSES.btnHidden);
      // hide notify btn
      parentEl.querySelector(this.SELECTORS.notifyMeBtn).classList.add(this.CLASSES.btnHidden);
    }
  }

  // ADD TO CART WITH NO FORM
  toggleAddToCartError(enable = true , productcode = false ){
    // find the right atc button
    let btn = document.querySelector("button.jsToBagBtn[data-code='"+productcode.substring(5)+"']");
    if(btn){
      if ( enable ) {
        btn.disable = false;
        btn.setAttribute('disabled','false');
      } else {
        btn.disable = true;
        btn.removeAttribute('disabled');
      }
    }
  }

  resetUnavailableForm() {
    this.mailInput.value = '';
  }

  // MAIN EVENTS
  bindEvents() {
    //
    let ctx = this;
    // on launch notify me , let's open the form
    this.$on(this.$customEvents.PRODUCT_EVENTS.notifyme, ({event, payload}) => {
      let payloadData = payload.box || payload.button;
      if (payloadData.classList.contains(this.CLASSES.enableNotify)) {
        ctx.toggleUnavailableForm(payloadData);
      } else {
        // if there is no notify form , i disable the atc
        let productcode = payloadData.querySelector('[data-sizes-trigger]').getAttribute('data-sizes-trigger');
        ctx.toggleAddToCartError(true,productcode);
      }
    });
    // hide form on notifyclose
    this.$on(this.$customEvents.PRODUCT_EVENTS.notifymeclose, ({event, payload}) => {
      // if its the main ATC btn for product
      if (payload.box == false) {
        ctx.toggleUnavailableForm(payload.button, true);
      } else if (payload.box.classList.contains(this.CLASSES.enableNotify)) {
        ctx.toggleUnavailableForm(payload.box, false);
      } else {
        // if there is no notify form , i enable the atc
        let productcode = payload.box.querySelector('[data-sizes-trigger]').getAttribute('data-sizes-trigger');
        ctx.toggleAddToCartError(false,productcode);
      }
    });

    // change size for notify me
    this.$on(this.$customEvents.PRODUCT_EVENTS.sizechanged, ({event, payload}) => {
      let currentSize = payload.button.getAttribute('data-product-code');
      // select only the affected product
      if (this.parent.querySelector('[data-product-code='+currentSize+']') != null) {
        // put size into form
        this.productCode.value = payload.button.getAttribute('data-size');
        this.sizeHiddenInput.value = payload.button.getAttribute('data-size');
      }
    });

    // fake click on notify button
    this.$on('click', (e) => {
      let uniqueSize = this.notifyMeBtn.getAttribute('data-unique-size') === 'true' ? true : false ;
      // if there is the selected size and uniquesize is false or if uniquesize is true
      if ( (this.sizeHiddenInput.value != '' && !uniqueSize ) || uniqueSize ) {
        // trigger sumbit form
        this.formBtn.click();
      } else {
        // no size selected
        if ( this.sizeHiddenInput.value == '' ) {
          this.sizeError.innerHTML = this.notifyMeBtn.getAttribute('data-select-size');
        }
      }

    }, this.notifyMeBtn );

    // submit form
    this.$on('submit', ({event}) => {
      //
      event.preventDefault();
      let $form = $(this.form);
      let url = $form.attr('action');
      let uniqueSize = this.notifyMeBtn.getAttribute('data-unique-size') === 'true' ? true : false;
      // reset errors
      $form.removeClass('error');

      if (this.sizeHiddenInput.value == '' && !uniqueSize) {
        this.sizeError.innerHTML = this.notifyMeBtn.getAttribute('data-select-size');
        return;
      }
      // SHOW LOADING
      $form.addClass('loading');
      ctx.notifyMeBtn.classList.add('loading');
      //if ($form.find('#email').val()) { <- why ?
      // ctx.$emit(ctx.$customEvents.LOADER_EVENTS.showLocal, { button: ctx.notifyMeBtn});
      // }
      // do ajax
      $.ajax({
        type: "POST",
        url: url,
        data: $form.serialize(),
        success: function(message, textStatus, xhr){
          // HIDE LOADING
          // ctx.$emit(ctx.$customEvents.LOADER_EVENTS.hideLocal, { button: ctx.notifyMeBtn} );
          ctx.notifyMeBtn.classList.remove('loading');
          // super effect wow
          // put label in the button
          const notificationLabel = ctx.notifyMeBtn.getAttribute('data-notification-thanks');
          ctx.notifyMeBtn.innerHTML = notificationLabel;
          ctx.mailInput.setAttribute('aria-invalid', 'false');
          ctx.liveRegion.sayMessage(notificationLabel);
          // after some time i want to be back to first state!!!
          setTimeout( ()=>{
            // HIDE LOADING
            $form.removeClass('loading');
            //
            // reset form
            ctx.resetUnavailableForm();
            // reset button label
            ctx.notifyMeBtn.innerHTML = ctx.notifyMeBtn.getAttribute('data-modal-title');
            // emit events - hide form and ended notifyme
            ctx.$emit(ctx.$customEvents.PRODUCT_EVENTS.notifymeclose , {box: false, button: ctx.notifyMeBtn });
            ctx.$emit(ctx.$customEvents.PRODUCT_EVENTS.notifymeended);
          },6000);
        },
        error: function(xhr){
          // hide loader
          ctx.$emit(ctx.$customEvents.LOADER_EVENTS.hideLocal, { button: ctx.notifyMeBtn} );
          ctx.notifyMeBtn.classList.remove('loading');
          $form.removeClass('loading');
          // error
          ctx.log('notifyMe submit error');
          // insert error
          ctx.mailErrorBox.innerHTML = xhr.responseText;
          ctx.liveRegion.sayMessage(xhr.responseText);
          ctx.mailInput.setAttribute('aria-invalid', 'true');
          ctx.mailErrorBox.classList.remove('hidden');
          // adding class
          $form.addClass('error');
        }
      });
    }, this.form);
  }

  render() {
    this.log("Rendering...");
    this.bindEvents();
  }
}
